import React from "react";
import { connect } from "react-redux";
import SearchGrid from "./Search/SearchGrid";

const globalSearchEnabled =
  process.env.REACT_APP_GLOBAL_SEARCH_ENABLED === "true";

class SearchDashboard extends React.Component {

  render() {
    if (!globalSearchEnabled) {
      return null;
    }

    return (
      <>
        <SearchGrid />
      </>
    );
  }
}

const mapStateToProps = (store) => ({
});

export default connect(mapStateToProps)(SearchDashboard);